import React, { useEffect, useState } from 'react';
import { lockLenis, unlockLenis } from '../utils/lenis';

function Popup({ trigger, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen((open) => !open);
  };

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    lockLenis();
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      unlockLenis();
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <>
      <div onClick={togglePopup}>{trigger}</div>
      {isOpen && (
        <div className='popup-background' onClick={togglePopup}>
          <div
            className='popup-content'
            data-lenis-prevent
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
}

export default Popup;
